import React from "react"

import useContents from "hooks/useContents"

import AddCompanyForm from "../AddCompanyForm/AddCompanyForm"
import styles from "./AddCompanyBlock.module.scss"

const AddCompanyBlock = () => {
  const contents = useContents()

  return (
    <div className={styles.wrapper}>
      <div className={styles.imageBlock}>
        {contents.subscribeImage && (
          <img
            src={contents.subscribeImage}
            alt="Добавить свою компанию на карту"
          />
        )}
      </div>

      <AddCompanyForm className={styles.newStyle} />
    </div>
  )
}

export default AddCompanyBlock
